import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  list({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`analysis/list`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getChapterList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`analysis/getChapterList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportChapterList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "analysis/exportChapterList",
        data: params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error);
        });
    });
  }
};
